package com.exura.components.dialogs

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.silk.style.CssStyleVariant
import com.varabyte.kobweb.silk.style.toModifier

@Composable
fun DialogContainer(
    onDismiss: () -> Unit,
    variant: CssStyleVariant<DialogPanelKind>? = null,
    content: @Composable () -> Unit
) {
    Box(
        contentAlignment = Alignment.Center,
        modifier = DialogOverlayStyle.toModifier()
            .onClick { onDismiss() }
    ) {
        Box(
            modifier = DialogPanelStyle
                .toModifier(variant)
                .onClick { it.stopPropagation() }
        ) {
            content()
        }
    }
}
